import * as tslib_1 from "tslib";
import { GrayoutService } from './grayout.service';
import { QUICK_QUOTE_CONSTANTS } from '../quick-quote.constants';
import { QuickQuoteService } from './quick-quote.service';
/**
 * This service handle the "New Itineraries" banner filter option behaviors
 * The banner is placed in the QQ and could be placed in a SPA page (ie: Cruise Listing Page)
 * This is a version 2, the filters are comming from translation key
 */
var NewItinerariesV2BannerService = /** @class */ (function () {
    function NewItinerariesV2BannerService(grayoutService, quickQuoteService) {
        this.grayoutService = grayoutService;
        this.quickQuoteService = quickQuoteService;
        this.available = false;
        /**
         * AnalyticsDataModel with default Analytics information
         * - "trackLinkID" is taken from filter information
         */
        this.analyticsDataModel = {
            trackLinkID: QUICK_QUOTE_CONSTANTS.analytics.cruiseFiltersLink +
                QUICK_QUOTE_CONSTANTS.analytics[QUICK_QUOTE_CONSTANTS.filters['more-filters'].id].filterButtonLink +
                '_' +
                QUICK_QUOTE_CONSTANTS.analytics[QUICK_QUOTE_CONSTANTS.filters['more-filters'].id]['new-sailings']
        };
    }
    /**
     * Determine the key to be added at the end of the filters applied, should be:
     *  Advance:[The title of the advance booking if they have the filter selected]
     *
     * Notes:
     * phase 1 (Disney Wish filter is used)
     *   - Advance: Disney Wish
     * phase 2 (New Sailings filter is used)
     *   - Advance: New Sailings
     *
     * @return string  the analytics key/value if filter is selected; otherwise empty string
     */
    NewItinerariesV2BannerService.prototype.getAnalyticsAdvBookingFilterValue = function () {
        var filterValue = '';
        if (this.isAvailable) {
            filterValue = QUICK_QUOTE_CONSTANTS.analytics.advBooking.prefix +
                QUICK_QUOTE_CONSTANTS.analytics.advBooking.phase2;
        }
        return filterValue;
    };
    /**
     * Retrive the filters values list availables for the banner
     *
     * @returns Array filters values list
     */
    NewItinerariesV2BannerService.prototype.getFiltersValues = function () {
        return this.quickQuoteService.getFiltersValues(this.bannerfilters.map(function (filter) { return filter.id; }));
    };
    /**
     * Initialize New Itineraries Banner filters
     * @param filterData the quick-quote filter groups
     * @param bannerfilters the banner filters, urlFriendlyId list
     */
    NewItinerariesV2BannerService.prototype.init = function (filterData, bannerfilterIds) {
        var _this = this;
        if (filterData && bannerfilterIds) {
            this.bannerfilterIds = bannerfilterIds;
            this.bannerfilters = [];
            this.available = true;
            // cache the filter data to use it subsequence when click on banner happens
            filterData.forEach(function (filter) {
                switch (filter.type) {
                    case QUICK_QUOTE_CONSTANTS.filters.date.id:
                        _this.addDateTypeFilters(filter.data);
                        break;
                    default:
                        break;
                }
            });
        }
    };
    Object.defineProperty(NewItinerariesV2BannerService.prototype, "isAvailable", {
        /**
         * Determine if the banner is available to use
         * @returns {boolean} - True when is available
         */
        get: function () {
            return this.available;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Determine if the banner filter is selected
     *
     * @returns boolean true if the filter applied to the banner is selected; otherwise it is false
     */
    NewItinerariesV2BannerService.prototype.isSelected = function () {
        return this.bannerfilters && this.bannerfilters.some(function (f) { return f.filterChanged.isSelected; });
    };
    /**
     * Behaviours when click on New Itineraries Banner
     */
    NewItinerariesV2BannerService.prototype.onClick = function (analyticsData) {
        var _this = this;
        this.quickQuoteService.clearAllFilters(true);
        this.bannerfilters.forEach(function (filter) {
            _this.selectQuickQuoteFilter(filter);
            _this.quickQuoteService.changedFilterItem(filter.filterChanged);
            _this.quickQuoteService.mergeIntoSelectedFilters();
            _this.grayoutService.checkGrayout();
            _this.quickQuoteService.updateCookieValueFromSelectedFilters();
            _this.quickQuoteService.updateURLFromCookieValue();
        });
        // update/define analytics props
        this.trackAnalytics(tslib_1.__assign({}, this.analyticsDataModel, analyticsData));
    };
    /**
     * Add Date type filters to bannerfilters cache
     * @param filters
     */
    NewItinerariesV2BannerService.prototype.addDateTypeFilters = function (filters) {
        var _this = this;
        filters.forEach(function (filter) {
            filter.contentData.forEach(function (filterContent) {
                if (_this.bannerfilterIds.includes(filterContent.urlFriendlyId)) {
                    _this.bannerfilters.push({
                        id: filterContent.id,
                        filter: filterContent,
                        filterChanged: {
                            filterType: QUICK_QUOTE_CONSTANTS.filters.date.id,
                            id: filterContent.id,
                            isSelected: filterContent.isSelected,
                            urlFriendlyId: filterContent.urlFriendlyId
                        },
                        disabled: filterContent.isDisabled
                    });
                }
            });
        });
    };
    /**
     * Mark a banner filter as selected
     * @param bannerFilter
     */
    NewItinerariesV2BannerService.prototype.selectQuickQuoteFilter = function (bannerFilter) {
        if (!bannerFilter.disabled) {
            bannerFilter.filter.isSelected = true;
            bannerFilter.filterChanged.isSelected = true;
        }
    };
    /**
     * Tack the analytics event
     *
     * @param analyticsDataModel analytics model to track the event
     */
    NewItinerariesV2BannerService.prototype.trackAnalytics = function (analyticsDataModel) {
        this.quickQuoteService.trackAnalyticsEvent(analyticsDataModel);
    };
    return NewItinerariesV2BannerService;
}());
export { NewItinerariesV2BannerService };
